import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaBus } from "react-icons/fa";
import Logo from "../assets/images/logo.png";
import {
  FaArrowCircleLeft,
  FaChevronCircleRight,
  FaFileInvoice,
  FaMoneyBillAlt,
  FaRegMoon,
} from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdHelpCircle, IoMdExit } from "react-icons/io";

export default function SiderBarComponent() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState("Empresas");
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Active Item:", activeItem);
  }, [activeItem]);

  return (
    <div className="flex h-screen bg-gray-100">
      <div
        className={`bg-white shadow-lg ${
          sidebarOpen ? "w-[280px]" : "w-[100px]"
        } transition-all duration-300 py-4`}
      >
        <div className="relative justify-between items-center">
          <div onClick={() => navigate("/")} className="flex w-full items-center justify-left mb-[20px] mt-[28px] ml-4 cursor-pointer">
            <img
              src={Logo}
              alt="AI handshake"
              className="w-[68px] object-cover rounded-xl mr-1 "
              
            />
            <h1
              className={`text-[40px] text-textTitle font-semibold ${
                !sidebarOpen && "hidden"
              }`}
            >
              PIXU
            </h1>
          </div>

          <button
            className="absolute right-[-12px]"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? (
              <FaArrowCircleLeft size={24} color="#56688E" />
            ) : (
              <FaChevronCircleRight size={24} color="#56688E" />
            )}
          </button>

          <div className="pl-6">
            <h3
              className={`text-[14px] text-textTipic font-regular mt-[50px] ${
                !sidebarOpen && "hidden"
              }`}
            >
              PANEL DE ADMINISTRADOR
            </h3>
            <h3
              className={`text-[16px] text-textTitle font-semibold mt-[5px] ${
                !sidebarOpen && "hidden"
              }`}
            >
              Juan Camilo G.
            </h3>
          </div>
        </div>
        <nav className="mt-[40px]">
          <ul>
            {sidebarOpen ? (
              <div
                className={`flex items-center pl-6 hover:bg-gray-200  ${
                  activeItem == "Empresas"
                    ? "bg-[#EAF0FC] drop-shadow-lg"
                    : "bg-none"
                }`}
              >
                <FaBus size={24} color="#3D3D3D" className="" />

                <li
                  onClick={() => {
                    setActiveItem("Empresas");
                    navigate("/empresas");
                    console.log(activeItem)
                  }}
                  className={` w-full flex items-center text-[14px] font-medium text-textSubtitle h-[76px] py-2 pl-4 cursor-pointer `}
                >
                  Empresas
                </li>
              </div>
            ) : (
              <div className="w-full h-[76px] flex items-center mt-[64px] justify-center">
                <FaBus
                  size={24}
                  color="#3D3D3D"
                  className="hover:bg-gray-200 cursor-pointer"
                />
              </div>
            )}

            {sidebarOpen ? (
              <div
                className={`flex items-center pl-6 hover:bg-gray-200  ${
                  activeItem == "Suscripciones"
                    ? "bg-[#EAF0FC] drop-shadow-lg "
                    : "bg-none"
                }`}
              >
                <FaFileInvoice size={24} color="#3D3D3D" className="" />

                <li
                  onClick={() => {
                    setActiveItem("Suscripciones");
                    navigate("/empresas/suscripcion");
                    console.log(activeItem)
                  } }
                  className={` w-full flex items-center text-[14px] font-medium text-textSubtitle h-[76px] py-2 pl-4 cursor-pointer `}
                >
                  Suscripciones
                </li>
              </div>
            ) : (
              <div className="w-full h-[76px] flex items-center justify-center">
                <FaFileInvoice
                  size={24}
                  color="#3D3D3D"
                  className="hover:bg-gray-200 cursor-pointer"
                />
              </div>
            )}

            {sidebarOpen ? (
              <div
                className={`flex items-center pl-6 hover:bg-gray-200  ${
                  activeItem == "financiero"
                    ? "bg-[#EAF0FC] drop-shadow-lg"
                    : "bg-none"
                }`}
              >
                <FaMoneyBillAlt size={24} color="#3D3D3D" className="" />

                <li
                   onClick={() => {
                    setActiveItem("financiero");
                    navigate("/empresas/transaction");
                    console.log(activeItem)
                  } }
                  className={` w-full flex items-center text-[14px] font-medium text-textSubtitle h-[76px] py-2 pl-4 cursor-pointer `}
                >
                  Control Financiero
                </li>
              </div>
            ) : (
              <div className="w-full h-[76px] flex items-center justify-center">
                <FaMoneyBillAlt
                  size={24}
                  color="#3D3D3D"
                  className="hover:bg-gray-200 cursor-pointer"
                />
              </div>
            )}

            {sidebarOpen ? (
              <div
                className={`flex items-center pl-6 hover:bg-gray-200  ${
                  activeItem == "georeferenciacion"
                    ? "bg-[#EAF0FC] drop-shadow-lg"
                    : "bg-none"
                }`}
              >
                <FaLocationDot size={24} color="#3D3D3D" className="" />

                <li
                   onClick={() => {
                    setActiveItem("georeferenciacion");
                    navigate("/empresas/location");
                    console.log(activeItem)
                  } }
                  className={` w-full flex items-center text-[14px] font-medium text-textSubtitle h-[76px] py-2 pl-4 cursor-pointer `}
                >
                  Georeferenciación
                </li>
              </div>
            ) : (
              <div className="w-full h-[76px] flex items-center  justify-center">
                <FaLocationDot
                  size={24}
                  color="#3D3D3D"
                  className="hover:bg-gray-200 cursor-pointer"
                />
              </div>
            )}

            <hr className="mt-[80px]"></hr>

            {sidebarOpen ? (
              <div
                className={`flex items-center pl-6 hover:bg-gray-200  ${
                  activeItem == "ayuda"
                    ? "bg-[#EAF0FC] drop-shadow-lg"
                    : "bg-none"
                }`}
              >
                <IoMdHelpCircle size={28} color="#3D3D3D" className="" />

                <li
                  onClick={() => setActiveItem("ayuda")}
                  className={` w-full flex items-center text-[14px] font-medium text-textSubtitle h-[76px] py-2 pl-4 cursor-pointer `}
                >
                  Ayuda
                </li>
              </div>
            ) : (
              <div className="w-full h-[76px] flex items-center  justify-center">
                <IoMdHelpCircle
                  size={28}
                  color="#3D3D3D"
                  className="hover:bg-gray-200 cursor-pointer"
                />
              </div>
            )}

            {sidebarOpen ? (
              <div className={`flex items-center pl-6 hover:bg-gray-200  `}>
                <IoMdExit size={28} color="#3D3D3D" className="" />
                <li
                  onClick={() => navigate("/login")}
                  className={` w-full flex items-center text-[14px] font-medium text-textSubtitle h-[76px] py-2 pl-4 cursor-pointer `}
                >
                  Salir
                </li>
              </div>
            ) : (
              <div className="w-full h-[76px] flex items-center  justify-center">
                <IoMdExit
                  size={28}
                  color="#3D3D3D"
                  className="hover:bg-gray-200 cursor-pointer"
                />
              </div>
            )}

            <hr></hr>

            {sidebarOpen ? (
              <div className={`flex items-center pl-6 hover:bg-gray-200  `}>
                <FaRegMoon size={28} color="#3D3D3D" className="" />
                <li
                  onClick={() => navigate("/login")}
                  className={` w-full flex items-center text-[14px] font-medium text-textSubtitle h-[76px] py-2 pl-4 cursor-pointer `}
                >
                  Modo Noche
                </li>
              </div>
            ) : (
              <div className="w-full h-[76px] flex items-center  justify-center">
                <FaRegMoon
                  size={28}
                  color="#3D3D3D"
                  className="hover:bg-gray-200 cursor-pointer"
                />
              </div>
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
}
